import http from "@/api/request";
import { SYSTEM_SERVICE_BASE } from "@/config/apiBaseUrlConfig";

import type {
  AddDictParams,
  DictTreeItem,
  DictTreeItemVO,
  GetDataDictTreeParams,
  UpdateDictParams,
} from "./type";

// 数据字典-树形查询 /service-chijing-system/api/system/getDictTree
export const getDictTree = () => {
  return http.get<DictTreeItemVO[]>(`${SYSTEM_SERVICE_BASE}/getDictTree`);
};

// 数据字典-管理端全量查询 /service-chijing-system/api/system/getDataDictTree
export const getDataDictTree = (params?: GetDataDictTreeParams) => {
  return http.get<DictTreeItem[]>(`${SYSTEM_SERVICE_BASE}/getDataDictTree`, { params });
};

// 新增数据字典 /service-chijing-system/api/system/addDataDict
export const addDataDict = (data: AddDictParams) => {
  return http.post(`${SYSTEM_SERVICE_BASE}/addDataDict`, data);
};

// 修改数据字典 /service-chijing-system/api/system/updateDataDict/{id}
export const updateDataDict = (id: string, data: UpdateDictParams) => {
  return http.put(`${SYSTEM_SERVICE_BASE}/updateDataDict/${id}`, data);
};

// 删除数据字典 /service-chijing-system/api/system/deleteDataDict/{id}
export const deleteDataDict = (id: string) => {
  return http.delete(`${SYSTEM_SERVICE_BASE}/deleteDataDict/${id}`);
};
